import DashboardIcon from "@mui/icons-material/Dashboard";
import { Outlet } from "react-router-dom";
import Dashboard from "../components/dashboard";
const DashboardLayout = () => {
  return <Outlet />;
};
const dashboardRoute = [
  {
    icon: DashboardIcon,
    name: "Dashboard",
    link: "/dashboard",
    path: "dashboard",
    element: <Dashboard />, // layout with <Outlet />

    index: 0,
  },
  {
    path: "dashboard/:pId",
    element: <Dashboard />,
  },
];
export default dashboardRoute;
